import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  name: string | null;
  email: string | null;
  logged: boolean;
  roleId: number | null;
  role: { name: string | null };
  groupId: number | null;
  group: { name: string | null };
  img: string | null;
}

const initialState: AuthState = {
  name: null,
  email: null,
  logged: false,
  roleId: 0,
  role: { name: "" },
  groupId: null,
  group: { name: "" },
  img: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    saveUser: (_state, action: PayloadAction<AuthState>) => {
      return { ...action.payload, logged: true };
    },
    logoutUser: () => initialState
  }
})

export const { saveUser, logoutUser } = authSlice.actions;

export default authSlice.reducer;